import {
  AfterViewInit,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {VanBanDenFile} from '../../../../models/vanbanden/vanbandenfile';
import {VanBanDenXL} from '../../../../models/vanbanden/vanbandenxl';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {VanBanDenXLService} from '../../../../service/vanbanden/service-vanbandenxl';

import {VanBanDenComment} from '../../../../models/vanbanden/vanbandencomment';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {environment} from '../../../../../environments/environment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {YKienXuLyVanBanDenComponent} from './ykienxuly.component';
import {ThoiHanVanBanDenComponent} from './thoihan.component';
import {TongHopYKienVanBanDenComponent} from './tonghop.component';
import {GXLCap2VanBanDenComponent} from '../giaoxuly/giaoxulycap2.component';
import {PdfShowComponent} from '../../view/pdf.component';
import {FileVanBanDenComponent} from './file.component';
import {DanhSachTHVanBanDenComponent} from './danhsach.component';
import {VanBanDenCommentService} from '../../../../service/vanbanden/service-vanbandencomment';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
import {DomSanitizer} from '@angular/platform-browser';
import {LogFileComponent} from '../../log/logfile.component';
import {LogView} from '../../../../models/log/logview';
import {LogViewService} from '../../../../service/log/service-logview';
import {YeuCauXuLy} from '../../../../models/yeucau/yeucauxuly';
@Component({
  selector: 'xulyvanbanden-detail',
  templateUrl: './xulydetail.component.html',
  encapsulation: ViewEncapsulation.None

})
export class XuLyDetailVanBanDenComponent implements OnInit, AfterViewInit {
  @Input() vanBanDenId: number = 0;
  @Output() backMethod: EventEmitter<string> = new EventEmitter();
  @Output() nextPage: EventEmitter<string> = new EventEmitter();
  @Output() backPage: EventEmitter<string> = new EventEmitter();
  private moduleName:  string = 'egov.info.vanbanden.xuly';
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public id: number = -1;
  public language = language;
  public showAction = true;
  public vanBanDenItem: VanBanDen = new VanBanDen();
  public vanBanDenFiles: VanBanDenFile[] = [];
  public vanBanDenXuLyItem: VanBanDenXL = new VanBanDenXL();
  public vanBanDenXuLyList: VanBanDenXL[] = [];
  public vanBanDenCommentList: VanBanDenComment[] = [];
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public permissionGXL: boolean = false;
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public trangThaiHoanThanh: number= environment.hoanthanh;
  public hoanThanhList: VanBanDenXL[] = [];
  public chuaXuLyList: VanBanDenXL[] = [];
  public daXemXuLyList: VanBanDenXL[] = [];
  public dangXuLyList: VanBanDenXL[] = [];
  public permissionYKien: boolean = false;
  public permissionTaiFileComment: boolean = false;
  public permissionChuyenHoanThanh: boolean = false;
  public permissionViewFile: boolean = false;
  public permissionDownloadFile: boolean = false;
  public permissionYKienTongHop: boolean = false;
  public permissionThayFile: boolean = false;
  public permissionGiaoCapDuoi: boolean = false;
  public permissionXuLyLai: boolean = false;
  public permissionSuaThoiHan: boolean = false;
  public ketQuaXuLyNguoiChuTri: String ="";
  public vanBanGiaoCap2List: VanBanDenXL[] = [];
  public logViewList: LogView[] = [];
  private dataComment: Object[] = [];
  constructor(
    public vanBanDenService: VanBanDenService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public vanBanDenFileService: VanBanDenFileService,
    public vanBanDenXuLyService: VanBanDenXLService,
    public rolePermissionService: RolePermissionService,
    public bsModalService: BsModalService,
    public vanBanDenCommentService: VanBanDenCommentService,
    public sanitizer: DomSanitizer,
    public logViewService: LogViewService
  ) {
  }
  ngAfterViewInit() {
  }
  public thoiHan() {
    const modalEdit = this.bsModalService.show(ThoiHanVanBanDenComponent);
    (<ThoiHanVanBanDenComponent>modalEdit.content).edit(
      this.vanBanDenId
    );
    (<ThoiHanVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        this.edit(this.vanBanDenId);
    });

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionYKien = x.findIndex(y => y.action === environment.ykien) !== -1;
      this.permissionTaiFileComment = x.findIndex(y => y.action === environment.taifilecomment) !== -1;
      this.permissionChuyenHoanThanh = x.findIndex(y => y.action === environment.chuyenhoanthanh) !== -1;
      this.permissionViewFile = x.findIndex(y => y.action === environment.xemfile) !== -1;
      this.permissionDownloadFile = x.findIndex(y => y.action === environment.download) !== -1;
      this.permissionYKienTongHop = x.findIndex(y => y.action === environment.ykientonghop) !== -1;
      this.permissionGiaoCapDuoi = x.findIndex(y => y.action === environment.giaocapduoi) !== -1;
      this.permissionThayFile = x.findIndex(y => y.action === environment.thayfile) !== -1;
      this.permissionXuLyLai = x.findIndex(y => y.action === environment.xulylai) !== -1;
      this.permissionSuaThoiHan = x.findIndex(y => y.action === environment.suathoihan) !== -1;
      this.edit(this.vanBanDenId);
      document.getElementById("refNote").setAttribute("value", "1" );

    });

  }
  public yKienXuLy() {
      const modalEdit = this.bsModalService.show(YKienXuLyVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<YKienXuLyVanBanDenComponent>modalEdit.content).edit(
        this.vanBanDenId
      );
      (<YKienXuLyVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        this.edit(this.vanBanDenId);
      });
    }
  showFile(id: number) {
    this.vanBanDenFileService.findAllByVanBanId(id).subscribe( x => {
      if( x.length > 0)
      {
        this.vanBanDenXuLyService.getByMaVBAndMXL(x[0].maVB, Sessioncommand.staffId).subscribe(
          data => {
          });
        const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
        (<PdfShowComponent>modalEdit.content).show(
          this.commandUtil.getUrlDownload(x[0].folder, x[0].fileKey, x[0].width, x[0].name)

        );
        (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
          if (result === true) {

          }
        });
      }
    });
  }
  public giaoXuLy() {
      const modalEdit = this.bsModalService.show(GXLCap2VanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<GXLCap2VanBanDenComponent>modalEdit.content).edit(
        this.vanBanDenId
      );
      (<GXLCap2VanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        this.edit(this.vanBanDenId);
      });

  }
  public yKienTongHop() {
    const modalEdit = this.bsModalService.show(TongHopYKienVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopYKienVanBanDenComponent>modalEdit.content).edit(
      this.vanBanDenId
    );
    (<TongHopYKienVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public thayFile(id: number) {
    const modalEdit = this.bsModalService.show(FileVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<FileVanBanDenComponent>modalEdit.content).edit(
      id
    );
    (<FileVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        this.edit(this.vanBanDenId);
    });
  }
  public changeStatus()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_hoanthanh_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDenXuLyService.changeStatus(this.vanBanDenId, environment.hoanthanh, Sessioncommand.staffId).subscribe(
          {
            next: (data) => {
              if(data !== -1)
              {
                this.toastr.success(language.change_hoanthanh_success, language.message);
                Sessioncommand.vanBanDenStatus = 0;
                Sessioncommand.notification = true;
              }else
                this.toastr.warning(language.error_message_success, language.message);

              this.edit(this.vanBanDenId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  public xuLyLai()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.message_xulylai_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDenXuLyService.xuLyLai(this.vanBanDenId, environment.chuaxuly, this.vanBanDenItem.maNguoiChuTri).subscribe(
          {
            next: (data) => {
              this.toastr.success(language.message_xulylai_success, language.message);
              Sessioncommand.vanBanDenStatus = 0;
              Sessioncommand.notification = true;
              this.edit(this.vanBanDenId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  public showXuLy(vanBanList: VanBanDenXL[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DanhSachTHVanBanDenComponent>modalEdit.content).edit(
      vanBanList
    );
    (<DanhSachTHVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public edit(id: number) {
    this.id = id;
    this.vanBanDenService.getById(id).subscribe(data => {
      this.vanBanDenItem = data;
      if ( data.maNguoiChuTri !== 0)
      {
        this.vanBanDenXuLyService.getByMaVBAndMNCT(id, data.maNguoiChuTri).subscribe(
          data2 => this.ketQuaXuLyNguoiChuTri = data2.ketQua);
      }
    });

    this.loadComment(id);
    this.vanBanDenXuLyService.getAllByMaVB(id).subscribe( data => {this.vanBanDenXuLyList = data;

      this.hoanThanhList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.hoanthanh);
      this.dangXuLyList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.dangxuly);
      this.chuaXuLyList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.chuaxuly && x.xem === 0);
      this.daXemXuLyList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.chuaxuly && x.xem === 1);
    });

    this.vanBanDenXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId ).subscribe(
        data => this.vanBanDenXuLyItem = data);
    this.vanBanDenFileService.findAllByVanBanId(id).subscribe(
      x => {
        this.vanBanDenFiles = x;
      });
    this.vanBanDenXuLyService.getByMaVBAndMaNguoiGiaoTiep(id, Sessioncommand.staffId).subscribe(
        data => this.vanBanGiaoCap2List = data
    );
  }
  public getLogView(id: number): LogView
  {
    return this.logViewList.find(x => x.refId === id);
  }

  public getXuLyById(sId: number, s: boolean): string
  {

    let xl: VanBanDenXL = this.vanBanDenXuLyList.find(x => x.maNguoiXuLy === sId);
    return xl == null ? "" : (s === true ?  xl.thoiGianXemLanDau: xl.thoiGianXemLanCuoi);

  }

  public loadComment(id: number)
  {
    this.logViewList  = [];
    this.vanBanDenCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.logViewService.findAllByMaVBAndStaffId(id, Sessioncommand.staffId, environment.VANBANDEN).subscribe(x => {
      this.logViewList = x;
      this.vanBanDenCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => {
        this.vanBanDenCommentList = data;
      });
    });
  }
  private checkNew(commentId: number): boolean
  {
    return this.logViewList.findIndex(x => x.refId === commentId) !== -1;
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.id);
  }
  public showLichSu()
  {
    const modalEdit = this.bsModalService.show(LogFileComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<LogFileComponent>modalEdit.content).show(
      "com.egov.api.repository.model.vanbanden.VanBanDenFile", this.vanBanDenId
    );

  }

}

